import { Layout, CountValueData } from "components"
export const CounterValue = () => {
 return (
  <Layout>
   <CountValueData />
  </Layout>
 )
}
